<template>
  <div class="col-list">
    <div v-for="(item, index) in houseList" :key="index + 10">
      <van-cell v-if="item.property" :class="item.property.propertyStatus === 3 || item.property.propertyStatus === 0 ? 'col_saled' : ''" @click="goUrl(item)">
        <van-card>
          <!-- 标题部分 -->
          <div slot="title" class="col-card__title">
            <div class="card__title">
              {{ item.property.titleWithCulture }}
            </div>
            <div class="card_img" v-if="relatedList != 'history'">
              <img src="../assets/icon_shar.png" alt="fenxiang" @click.stop="shareView(item)">
              <img v-if="item.collectionID || collection_List" src="../assets/icon_redHard.png" alt="shouchang" @click.stop="deleteCollection(item, index, item.property.rentalType)">
              <img v-else src="../assets/icon_whiteHard.png" alt="shouchang" @click.stop="addCollection(index, item.property.propertyID, item.property.rentalType, item)">
            </div>
          </div>
          <!-- 图片部分 -->
          <div slot="thumb" :class="['col-card__thumb',{'col-card__thumb__border': item.property.topType === 3}]">
            <div class="icon reviewed" v-if="item.property.propertyLabel && item.property.propertyLabel[1]"><img src="../assets/vr.gif" /></div>
            <div v-if="item.property.propertyLabel && item.property.propertyLabel[3] && !item.property.propertyLabel[1]">
              <svg class="icon reviewed" aria-hidden="true">
                <use xlink:href="#icon-yingpian"></use>
              </svg>
            </div>
            <!-- 收藏按钮状态取消 -->
            <!-- <div class="col-icon">
              <img src="@/assets/soucang.png" style="width: 20px; height: 20px" alt="" />
            </div> -->
            <!-- <img class="img-hse" :src="item.property.imagePath|imgResize('company')" onerror="errorImg(this)" /> -->
            <img class="img-hse" v-lazy="pub.imgResize(item.property.imagePath, 'company')" onerror="errorImg(this)" />
            <!--封盤 已租或已售 -->
            <p v-if="item.property.propertyStatus === 3 || item.property.propertyStatus === 0" class="saled">{{ item.property.propertyStatusWithCulture }}</p>
          </div>
          <!-- 置顶标签 -->
          <div slot="tag" class="col-tag">
            <p v-if="item.property.topType" :class="['col-top',{colsel:item.property.topType==1?true:false}]"><img v-if="item.property.topType === 3" src="@/assets/starStar.png" alt="">{{ item.property.topTypeWithCulture }}</p>
            <p :class="lang.type === 'en-us' ? 'col-reviewd-en' : 'col-reviewd'" v-if="item.property.isVerifyLabel">{{ lang.verifyLabel }}</p>
            <!-- 图片总数 -->
            <p class="imageNumber" v-if="item.property.imageNumber">{{item.property.imageNumber}}</p>
          </div>
          <!-- 平面图和业主盘标签 -->
          <div slot="tag" class="col-label">
            <p :class="lang.type === 'en-us' ? 'col-landlord-d-en' : 'col-landlord-d'" v-if="item.property.propertySource === 1">
              <img class="icon" src="@/assets/yezhupan.svg" />
              <span :class="lang.type === 'en-us' ? 'landlord-en' : 'landlord'">{{ lang.Landlord }}</span>
            </p>
            <p :class="lang.type === 'en-us' ? 'col-plane-d-en' : 'col-plane-d'" v-if="item.property.propertyLabel && item.property.propertyLabel[7]">
              <img class="icon" src="@/assets/pingmiantu.svg" />
              <span :class="lang.type === 'en-us' ? 'plane-en' : 'plane'">{{ lang.plane }}</span>
            </p>
          </div>
          <!-- 分类标签 -->
          <div slot="tags" class="col-desc col-adress">
            <!-- 屋苑+期数 -->
            <span class="card-tags">{{ item.property.estateNameWithCulture }} {{ item.property.phaseWithCulture }}</span>
          </div>
          <!-- 间隔+层数 -->
          <div slot="tags" class="col-desc">
            <!-- <span>Open Style 5+ Bathroom(s) | Ground Floor</span> -->
            <span v-if="item.property.roomNumberWithCulture">{{ item.property.roomNumberWithCulture }}&nbsp;</span>
            <span v-if="item.property.toiletNumberWithCulture">{{ item.property.toiletNumberWithCulture }}&nbsp;</span>
            <span v-if="item.property.unitFloorWithCulture">{{ item.property.toiletNumberWithCulture ? '|&nbsp;' + item.property.unitFloorWithCulture : item.property.unitFloorWithCulture }}</span>

            <div class="reducePrice" v-if="item.property.isReducePaidSalePrice || item.property.isReduceRentPrice">
              <span v-if="item.property.subCategory && (item.property.subCategory[6] || item.property.subCategory[7]) && item.property.rentalType == 1" class="saleform"
                >{{ lang.saleFormPaid }} &nbsp;</span
              >
              <span class="decmid">{{ tool.getPrice(item.property.rentalType === 1 ? item.property.firstPaidSalePrice : item.property.firstRentPrice, lang.type).replace(/[^0-9|$|.]/gi, '') }}
              
              <span v-if="(item.property.firstRentPrice>100000&& item.property.rentalType ==2) || item.property.rentalType === 1">{{
              tool
                .getPrice(item.property.rentalType === 1 ? item.property.firstPaidSalePrice : item.property.firstRentPrice, lang.type)
                .substring(tool.getPrice(item.property.rentalType === 1 ? item.property.firstPaidSalePrice : item.property.firstRentPrice, lang.type).length - 1)}}</span>
                </span>
              <span class="redRatio">&nbsp;{{ item.property.rentalType === 1 ? item.property.reducePaidSalePriceRatio : item.property.reduceRentPriceRatio }}%</span>
            </div>
            <div class="reducePrice" v-if="item.property.isReduceUnPaidSalePrice">
              <span class="saleform">{{ lang.saleFormUnpaid }} &nbsp;</span>
              <span class="decmid">{{ tool.getPrice(item.property.firstUnPaidSalePrice, lang.type).replace(/[^0-9|$|.]/gi, '') }}
              {{
                  tool
                    .getPrice(item.property.firstUnPaidSalePrice, lang.type)
                    .substring(tool.getPrice(item.property.firstUnPaidSalePrice, lang.type).length - 1)
                }}
                </span>
              <span class="redRatio">&nbsp;{{ item.property.reduceUnPaidSalePriceRatio }}%</span>
            </div>
          </div>
        </van-card>
        <!-- 价格部分 -->
        <div class="bh-price col-adress" v-if="item.property.paidSalePrice || item.property.rentPrice">
          <div class="bh-plane"></div>
          <!--已補地價1未补，2已补，自由市場 綠表價/白居二  只展示固定类型楼盘-->
          <span v-if="item.property.subCategory && (item.property.subCategory[6] || item.property.subCategory[7]) && item.property.rentalType == 1" class="saleform"
            >{{ lang.saleFormPaid }} &nbsp;</span
          >
          <span v-if="relatedList != 'history'" :class="['card-price',{'card-price-green': item.property.rentalType === 2}]">{{ item.property.rentalType === 2 ? lang.listRent : lang.listBuy }}</span>
          <span :class="['card-price',{'card-price-green': item.property.rentalType === 2}]">{{ tool.getPrice(item.property.rentalType === 1 ? item.property.paidSalePrice : item.property.rentPrice, lang.type).replace(/[^0-9|$|.]/gi, '') }} </span
          >
          <span
          :class="{'card-price-small-en': lang.type === 'en-us', 'card-price-small': lang.type !== 'en-us', 'card-price-green': item.property.rentalType === 2}"
            v-if="
              tool
                .getPrice(item.property.rentalType === 1 ? item.property.paidSalePrice : item.property.rentPrice, lang.type)
                .substring(tool.getPrice(item.property.rentalType === 1 ? item.property.paidSalePrice : item.property.rentPrice, lang.type).length - 1)
                .search(/[\d]/gi) === -1
            "
            >{{
              tool
                .getPrice(item.property.rentalType === 1 ? item.property.paidSalePrice : item.property.rentPrice, lang.type)
                .substring(tool.getPrice(item.property.rentalType === 1 ? item.property.paidSalePrice : item.property.rentPrice, lang.type).length - 1)
            }}</span
          >
          <div class="col-price">
            <div class="practical col-adress">
              <span class="practical-top">
                {{ tool.getAreaToText('', item.property.saleableArea, lang.type, item.property.isVerifyArea) }}
              </span>
              <span v-if="item.property.saleableAvgPaidPrice" class="practical-bottom" style="font-size: 11px">
                {{ tool.getAvgPriceToText('', item.property.saleableAvgPaidPrice, lang.type) }}
              </span>
              <span v-if="item.property.saleableAvgPaidPrice && item.property.subCategory && (item.property.subCategory[6] || item.property.subCategory[7]) && item.property.rentalType == 1"
                >{{ lang.saleFormPaid }} &nbsp;</span
              >
            </div>
            <div class="build col-adress">
              <span class="build-top">
                {{ tool.getAreaToText(item.property.buildingArea, '', lang.type, item.property.isVerifyArea) }}
              </span>
              <span v-if="item.property.buildingAvgPaidPrice" class="build-bottom" style="font-size: 11px">
                {{ tool.getAvgPriceToText(item.property.buildingAvgPaidPrice, '', lang.type) }}
              </span>
              <span v-if="item.property.buildingAvgPaidPrice && item.property.subCategory && (item.property.subCategory[6] || item.property.subCategory[7]) && item.property.rentalType == 1"
                >{{ lang.saleFormPaid }} &nbsp;</span
              >
            </div>
          </div>
        </div>
        <!-- 居屋/夹屋 售价问题-->
        <div
          class="bh-price col-adress"
          v-if="item.property.unPaidSalePrice && item.property.subCategory && (item.property.subCategory[6] || item.property.subCategory[7]) && item.property.rentalType == 1"
        >
          <div class="bh-plane"></div>
          <!--已補地價1未补，2已补，自由市場 綠表價/白居二  只展示固定类型楼盘-->
          <span class="saleform">{{ lang.saleFormUnpaid }} &nbsp;</span>
          <span v-if="relatedList != 'history'" :class="['card-price',{'card-price-green': item.property.rentalType === 2}]">{{ item.property.rentalType === 2 ? lang.listRent : lang.listBuy }}</span>
          <span class="card-price">{{ tool.getPrice(item.property.unPaidSalePrice, lang.type).replace(/[^0-9|$|.]/gi, '') }} </span
          ><span
            :class="lang.type === 'en-us' ? 'card-price-small-en' : 'card-price-small'"
            v-if="
              tool
                .getPrice(item.property.rentalType === 1 ? item.property.unPaidSalePrice : item.property.rentPrice, lang.type)
                .substring(tool.getPrice(item.property.rentalType === 1 ? item.property.unPaidSalePrice : item.property.rentPrice, lang.type).length - 1)
                .search(/[\d]/gi) === -1
            "
            >
            {{
              tool
                .getPrice(item.property.rentalType === 1 ? item.property.unPaidSalePrice : item.property.rentPrice, lang.type)
                .substring(tool.getPrice(item.property.rentalType === 1 ? item.property.unPaidSalePrice : item.property.rentPrice, lang.type).length - 1)
            }}
            </span
          >
          <div class="col-price">
            <div class="practical col-adress">
              <span class="practical-top" v-if="!item.property.paidSalePrice">
                {{ tool.getAreaToText('', item.property.saleableArea, lang.type, item.property.isVerifyArea) }}
              </span>
              <span class="practical-bottom" style="font-size: 11px">
                {{ tool.getAvgPriceToText('', item.property.saleableAvgUnPaidPrice, lang.type) }}
              </span>
              <span v-if="item.property.saleableAvgUnPaidPrice">{{ lang.saleFormUnpaid }}</span>
            </div>
            <div class="build col-adress">
              <span class="build-top" v-if="!item.property.paidSalePrice">
                {{ tool.getAreaToText(item.property.buildingArea, '', lang.type, item.property.isVerifyArea) }}
              </span>
              <span class="build-bottom" style="font-size: 11px">
                {{ tool.getAvgPriceToText(item.property.buildingAvgUnPaidPrice, '', lang.type) }}
              </span>
              <span v-if="item.property.buildingAvgUnPaidPrice">{{ lang.saleFormUnpaid }}</span>
            </div>
          </div>
        </div>
        <div class="contacts" v-if="relatedList != 'history'">
          <div class="col-plane"></div>
          <div class="contacts_content">
            <img :src="item.contactImagePath | imgResize('user')" style="border-radius: 50%;" alt="" @click.stop="showDialog(item)">
            <img :class="{'button-grayed-out': !item.telphone}" src="../assets/icon_telephone.png" alt="" @click.stop="handlePhone(item, index)">
            <img :class="{'button-grayed-out': !item.isShowWhatsApp || !item.whatsApp}" src="../assets/icon_whatsapp.png" alt="" @click.stop="handleWhatsApp(item, index)">
          </div>
        </div>
        <!-- 标签 -->
        <div class="bottom">
          <div class="col-plane"></div>
          <div class="info-property-tags">
            <!-- 住宅 单栋式大厦 -->
            <template v-if="item.property.propertyCategoryWithCulture">
              <span class="tags-span property col-adress"
                >{{ item.property.propertyCategoryWithCulture }}
                <span v-for="(it, i) in item.property.subCategoryInfos" :key="i+10"> {{ it.name }}<span v-if="i !== item.property.subCategoryInfos.length - 1"> | </span></span>
              </span>
            </template>
            <template v-if="item.property.rentLabel">
              <span class="tags-span property col-adress" v-for="(it, i) in item.property.rentLabel" :key="i+10" v-if="i == 3 || i == 4 || i == 5 || i == 8">{{ it }}</span>
            </template>
            <template v-if="item.property.propertyTag">
              <span v-for="(it, i) in item.property.propertyTag" :key="i+10">
                <span class="tags-span col-adress" v-if="i < 5">{{ it.propertyTagName }}</span>
              </span>
            </template>
          </div>
        </div>
        <div class="col-remark-width">
          <!-- <p class="bh-company col-adress">{{getCompany(item.property.companyNameWithCulture,item.property.propertySource)}}</p> -->
          <p class="col-remark" v-if="item.remark">{{ lang.collectionNotes }}：{{ item.remark }}</p>
          <!-- <p v-else class="col-remark col-adress"></p> -->
        </div>
      </van-cell>
      <van-dialog
        class="vanDialog"
        v-model="show"
        :show-confirm-button=false
        :show-cancel-button=false
        >
        <div class="dialogClose">
          <img src="../assets/closeIcon.png" alt="" @click="show = !show">
        </div>
        <img class="image-container outer-border inner-border" :src="selectedItem.contactImagePath | imgResize('user')" alt="">
        <div class="dialogTitle">{{ selectedItem.contactNameCN }} {{ selectedItem.contactNameEN }}</div>
        <div class="dialogNumber">{{ selectedItem.agentLicenceNumber }}</div>
        <div v-if="selectedItem.accountID" class="dialogButton" @click="agentView(selectedItem)">
          <span>{{ lang.agencyPage }}</span>
          <img src="../assets/rightView.png" alt="">
        </div>
      </van-dialog>
      <!-- <ShareNetwork
        network="facebook"
        url="https://www.baidu.com"
        title="Say hi to Vite! A brand new, extremely fast development setup for Vue."
        description="This week, I’d like to introduce you to 'Vite', which means 'Fast'. It’s a brand new development setup created by Evan You."
        quote="The hot reload is so fast it\'s near instant. - Evan You"
        hashtags="vuejs,vite"
      >
        Share on Facebook
      </ShareNetwork> -->
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";
import pub from '../../common/public';
import lang from '../../common/language/history';
import tool from '../../common/js/tools.js';
const _conf = require('../../common/js/_conf');
export default {
  data() {
    return {
      tool,
      lang,
      houseDetail: {},
      show: false,
      selectedItem: {},
      userData: {},
      targetName:'',
    };
  },
  props: {
    houseList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    relatedList: {
      type: String,
      default: () => {
        return '';
      },
    },
    collection_List: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    mark: {
      type: String,
      default: () => {
        return '';
      },
    },
  },
  created() {
    this.lang.type = this.pub.getLang();
    this.fetchUserInfo();
    this.targetName = this.$route.name == 'subscribe' ? 'Subscribe':'Bookmark'
    console.log("window",this.$route.name)
  },
  methods: {
    fetchUserInfo() {
      this.pub.getUserInfo().then(res => {
        this.userData = res;
      }).catch();
    },
    agentView(item) {
      const base = _conf.env_type == 4 ? 'https://sim.house730.com':_conf.env_type == 3 ?'https://www.house730.com':'https://uat.house730.com.cn'
      const type = this.lang.type === 'zh-hk' ? '' : this.lang.type + '/';
      location.href = `${base}/${type}partner/${item.accountID}/`;
      if(window.dataLayer) {
        window.dataLayer.push({
          "event": "listingAgency",
          "source": this.mark == 'subscribe' ? "SRP-Subscription-Agent-Popup" : "SRP-Bookmark-Agent-Popup",
          "target": '',
          "user":  {
            "language":  `${window._language}`,
            "id":  `${this.userData.userID}`,
          },
          "listing": {
            "id": item.property.propertyID,
            "region": item.property.regionNameWithCulture || '',
            "district": (item.property.zoneNameWithCulture || '') + '，' + (item.property.gscopeNameWithCulture || ''),
            "building": item.property.estateNameWithCulture || '',
            "productType": '',
            "channel": item.property.rentalType === 1 ? 'buy' : 'rent',
            "propertyType": item.property.isServiceApartment ? item.property.subCategory[19] : '',
            "agencyId": item.accountID ? 'A' + item.accountID : 'U' + item.userID,
          }
        })
      }
    },
    showDialog(item) {
      this.selectedItem = item;
      this.show = true;
      if(window.dataLayer) {
        window.dataLayer.push({
          "event": "listingAgency",
          "source": this.mark == 'subscribe' ? "SRP-Subscription" : "SRP-Bookmark",
          "target": '',
          "user":  {
            "language":  `${window._language}`,
            "id":  `${this.userData.userID}`,
          },
          "listing": {
            "id": item.property.propertyID,
            "region": item.property.regionNameWithCulture || '',
            "district": (item.property.zoneNameWithCulture || '') + '，' + (item.property.gscopeNameWithCulture || ''),
            "building": item.property.estateNameWithCulture || '',
            "productType": '',
            "channel": item.property.rentalType === 1 ? 'buy' : 'rent',
            "propertyType": item.property.isServiceApartment ? item.property.subCategory[19] : '',
            "agencyId": item.accountID ? 'A' + item.accountID : 'U' + item.userID,
          }
        })
      }
    },
    handleWhatsApp(item, index) {
      console.log(!item.isShowWhatsApp || !item.whatsApp,"----------",item,index)
      // if (!item.isShowWhatsApp && !item.whatsApp) {
      if (!item.isShowWhatsApp || !item.whatsApp) {
        return
      }
      // 点击whatsapp图标
      let shareUrl = ''
      this.houseDetail = item.property
      let url = ''
      const base = _conf.env_type == 4 ? 'https://sim.house730.com':_conf.env_type == 3 ?'https://www.house730.com':'https://uat.house730.com.cn'
      const type = this.lang.type === 'zh-hk' ? '' : this.lang.type + '/';
      // 不加尾部中文参数
      if (item.property.rentalType === 1) {
        url = `${base}/${type}buy-property-${item.property.propertyID}/`;
      } else if (item.property.rentalType === 2) {
        url = `${base}/${type}rent-property-${item.property.propertyID}/`;
      }
      const shareText = this.lang.whatsAppShare1
      const shareName = this.houseDetail.propertySource === 2 ? item.contactNameCN : `${shareText[0]}${item.contactNameCN}`
      const phaseWithCulture = pub.getSeoText(this.houseDetail.phaseWithCulture)
      const shareRegion = pub.getSeoText(this.houseDetail.gscopeNameWithCulture)
      const gscopeNameWithCulture = this.houseDetail.gscopeNameWithCulture
      const shareEstate = pub.getSeoText(this.houseDetail.estateNameWithCulture)
      const estateNameWithCulture = this.houseDetail.estateNameWithCulture
      const sharePrice = this.houseDetail.rentalType === 1 ? tool.getPrice(this.houseDetail.salePrice, this.lang.type) : tool.getPrice(this.houseDetail.rentPrice, this.lang.type)
      let shareArea = ''
      if (this.houseDetail.buildingArea && this.houseDetail.saleableArea) {
        shareArea = this.houseDetail.buildingArea + '/' + this.houseDetail.saleableArea + this.lang.areaDimension
      } else if (this.houseDetail.buildingArea && !this.houseDetail.saleableArea) {
        shareArea = this.houseDetail.buildingArea + '' + this.lang.areaDimension
      } else if (!this.houseDetail.buildingArea && this.houseDetail.saleableArea) {
        shareArea = this.houseDetail.saleableArea + '' + this.lang.areaDimension
      }
      shareUrl = `${pub.shareWhatsAppUrl}?phone=${item.whatsAppCode.replace("+",'') + item.whatsApp}&text=${shareName}${this.houseDetail.rentalType === 1 ? `${shareText[1]}` : `${shareText[2]}`}【${gscopeNameWithCulture}${estateNameWithCulture}】 ${this.houseDetail.rentalType === 1 ? `${shareText[3]}` : `${shareText[4]}`}${sharePrice} ${shareText[5]}${shareArea}，${shareText[6]}${url}${shareEstate ? shareRegion + '-' : shareRegion}${phaseWithCulture ? shareEstate + '-' : shareEstate}${phaseWithCulture}/?utm_source=whatsapp`
      location.href = shareUrl;
      if(window.dataLayer) {
        window.dataLayer.push({
          "event": "listingWhatsapp",
          "source": this.mark == 'subscribe' ? "SRP-Subscription" : "SRP-Bookmark",
          "target": '',
          "user":  {
            "language":  `${window._language}`,
            "id":  `${this.userData.userID}`,
          },
          "listing": {
            "id": item.property.propertyID,
            "region": item.property.regionNameWithCulture || '',
            "district": (item.property.zoneNameWithCulture || '') + '，' + (item.property.gscopeNameWithCulture || ''),
            "building": item.property.estateNameWithCulture || '',
            "productType": item.property.topTypeWithCulture || '',
            "channel": item.property.rentalType === 1 ? 'buy' : 'rent',
            "propertyType": item.property.isServiceApartment ? item.property.subCategory[19] : '',
            "agencyId": item.accountID ? 'A' + item.accountID : 'U' + item.userID,
          }
        })
      }
    },
    handlePhone(item, index) {
      console.log("handlePhone",!item.isShowTel)
      if (!item.isShowTel) {
        return
      }
      let PHONE_NUMBER =  item.phoneCode.indexOf('852') > -1 ? item.telphone : item.phoneCode + item.telphone || item.companyTel || item.customerTel;
      location.href = `tel:${PHONE_NUMBER}`;
      if(window.dataLayer) {
        window.dataLayer.push({
          "event": "listingPhone",
          "source": this.mark == 'subscribe' ? "SRP-Subscription" : "SRP-Bookmark",
          "target": '',
          "user":  {
            "language":  `${window._language}`,
            "id":  `${this.userData.userID}`,
          },
          "listing": {
            "id": item.property.propertyID,
            "region": item.property.regionNameWithCulture || '',
            "district": (item.property.zoneNameWithCulture || '') + '，' + (item.property.gscopeNameWithCulture || ''),
            "building": item.property.estateNameWithCulture || '',
            "productType": item.property.topTypeWithCulture || '',
            "channel": item.property.rentalType === 1 ? 'buy' : 'rent',
            "propertyType": item.property.isServiceApartment ? item.property.subCategory[19] : '',
            "agencyId": item.accountID ? 'A' + item.accountID : 'U' + item.userID,
          }
        })
      }
    },
    shareView(item) {
      let url = ''
      const base = _conf.env_type == 4 ? 'https://sim.house730.com':_conf.env_type == 3 ?'https://www.house730.com':'https://uat.house730.com.cn'
      const type = this.lang.type === 'zh-hk' ? '' : this.lang.type + '/';
      // 不加尾部中文参数
      if (item.property.rentalType === 1) {
        url = `${base}/${type}buy-property-${item.property.propertyID}/`;
      } else if (item.property.rentalType === 2) {
        url = `${base}/${type}rent-property-${item.property.propertyID}/`;
      }
      if(window.dataLayer) {
        window.dataLayer.push({
          "event": "listingShare",
          "source": this.mark == 'subscribe' ? "SRP-Subscription" : "SRP-Bookmark",
          "target": '',
          "user":  {
            "language":  `${window._language}`,
            "id":  `${this.userData.userID}`,
          },
          "listing": {
            "id": item.property.propertyID,
            "region": item.property.regionNameWithCulture || '',
            "district": (item.property.zoneNameWithCulture || '') + '，' + (item.property.gscopeNameWithCulture || ''),
            "building": item.property.estateNameWithCulture || '',
            "productType": '',
            "channel": item.property.rentalType === 1 ? 'buy' : 'rent',
            "propertyType": item.property.isServiceApartment ? item.property.subCategory[19] : '',
            "agencyId": item.accountID ? 'A' + item.accountID : 'U' + item.userID,
            // "agencyId": item.accountID ||''
          }
        })
      }
      // 加URL尾部中文参数
      // if (item.property.rentalType === 1) {
      //   url = `${base}/${type}buy-property-${item.property.propertyID}/${item.property.gscopeNameWithCulture}-${item.property.estateNameWithCulture}-${item.property.phaseWithCulture}/`;
      // } else if (item.property.rentalType === 2) {
      //   url = `${base}/${type}rent-property-${item.property.propertyID}/${item.property.gscopeNameWithCulture}-${item.property.estateNameWithCulture}-${item.property.phaseWithCulture}/`;
      // }
      // 使用浏览器知道的分享弹窗，但是部分浏览器不兼容
      // let _title = item.property.titleWithCulture
      // if (navigator.share) {
      //   navigator.share({
      //     title: _title,
      //     text: '分享内容',
      //     url: url
      //   })
      //     .then(() => console.log('分享成功'))
      //     .catch((error) => console.log('分享失败', error));
      // } else {
      //   console.log('浏览器不支持分享功能');
      // }
      let copyVaule = ''
      copyVaule = url
      const input = document.createElement('input');
      document.body.appendChild(input);
      input.setAttribute('value', copyVaule);
      input.select();
      if (document.execCommand('copy')) {
        document.execCommand('copy');
      }
      // 删除'虚拟'DOM
      document.body.removeChild(input);
      Toast(this.lang.copySuccessText)
    },
    addCollection(index,estateId,type,item){
      if(window.dataLayer) {
        window.dataLayer.push({
          "event": "listingSave",
          "source": this.mark == 'subscribe' ? "SRP-Subscription" : "SRP-Bookmark",
          "target": '',
          "user":  {
            "language":  `${window._language}`,
            "id":  `${this.userData.userID}`,
          },
          "listing": {
            "id": item.property.propertyID,
            "region": item.property.regionNameWithCulture || '',
            "district": (item.property.zoneNameWithCulture || '') + '，' + (item.property.gscopeNameWithCulture || ''),
            "building": item.property.estateNameWithCulture || '',
            "productType": '',
            "channel": item.property.rentalType === 1 ? 'buy' : 'rent',
            "propertyType": item.property.isServiceApartment ? item.property.subCategory[19] : '',
            "agencyId": item.accountID ? 'A' + item.accountID : 'U' + item.userID,
          }
        })
      }
      this.$emit('canaddCollection',index,estateId,type)
    },
    deleteCollection(id,index,type){
      const token = this.pub.getCookie('cEVaUDFrZ1kd0RA');
      /** 判断是否登录 */
      if (!token) {
        /** 跳转登录页面 */
        const curLang = this.lang.type === 'zh-hk' ? '' : this.lang.type + '/';
        location.href = location.origin + `/my/${curLang}login?referrer=` + location.href;
      } else {
        this.$emit('cancelCollection',id,index,type);
      }
    },
    getCompany(company, property) {
      if (!company && property === 1) {
        return this.lang.landlord;
      } else if (!company && property === 2) {
        return this.lang.agency;
      } else if (company) {
        return company;
      }
    },
    // 租标签
    rentLabel(val) {
      if (val) {
        if (val[3] && val[4]) {
          return `${this.lang.shortRent}${this.lang.sublet}`;
        } else if (val[3]) {
          return this.lang.shortRent;
        } else if (val[4]) {
          return this.lang.sublet;
        }
      }
    },
    goUrl(item) {
      // if (!item.isShowWhatsApp || !item.whatsApp) {
      //   return; // 如果子元素不可点击，则不执行父元素的点击事件
      // }
      console.log("goUlr",item)
      const base = _conf.env_type == 4 ? 'https://sim.house730.com':_conf.env_type == 3 ?'https://www.house730.com':'https://uat.house730.com.cn'
      const type = this.lang.type === 'zh-hk' ? '' : this.lang.type + '/';
      if (item.property.rentalType === 1) {
        location.href = `${base}/${type}buy-property-${item.property.propertyID}/`;
      } else if (item.property.rentalType === 2) {
        location.href = `${base}/${type}rent-property-${item.property.propertyID}/`;
      }
      if(window.dataLayer && this.relatedList != 'history') {
        window.dataLayer.push({
          "event": "listingClick",
          "source": this.mark == 'subscribe' ? "SRP-Subscription" : "SRP-Bookmark",
          "target": '',
          "user":  {
            "language":  `${window._language}`,
            "id":  `${this.userData.userID}`,
          },
          "listing": {
            "id": item.property.propertyID,
            "region": item.property.regionNameWithCulture || '',
            "district": (item.property.zoneNameWithCulture || '') + '，' + (item.property.gscopeNameWithCulture || ''),
            "building": item.property.estateNameWithCulture || '',
            "productType": item.property.topTypeWithCulture || '',
            "channel": item.property.rentalType === 1 ? 'buy' : 'rent',
            "propertyType": item.property.propertyCategoryWithCulture || '',
            "agencyId": item.accountID ? 'A' + item.accountID : 'U' + item.userID,
          }
        })
      }
    },
  },
};
</script>
<style scoped lang="scss">
.van-card:not(:first-child) {
  margin: 0;
}
.col-list {
  margin-left: 15px;
  box-sizing: border-box;
}
.van-cell {
  padding: 15px 0px 10px 0;
  border-bottom: 1px solid #ebedf0;
  box-sizing: border-box;
  position: relative;
  top: 0;
  left: 0;
}
.col_saled {
  opacity: 0.55;
  pointer-events: none;
}
.van-card__title {
  font-size: 17px;
  color: #333333;
  font-weight: bold;
  min-height: 45px;
  max-height: 46px;
  line-height: 23px;
  padding-right: 15px;
}
.col-desc {
  font-size: 12px;
  line-height: 19px;
  color: #666666;
}
.reducePrice {
  margin-bottom: 4px;
  height: 16px;
  line-height: 16px;
}
.decmid {
  text-decoration: line-through;
  font-family: PingFangSC-SNaNpxibold;
  font-weight: 600;
  font-size: 12px;
  color: #999999;
  letter-spacing: 0;
  line-height: 16px;
}
.saleform {
  font-size: 10px !important;
  color: #999999 !important;
}
.redRatio {
  font-weight: bold;
  font-size: 12px !important;
  color: #333333 !important;
}
.col-adress {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.col-card__title {
  display: flex;
  justify-content: space-between;
  .card__title {
    font-size: 17px;
    color: #333333;
    font-weight: bold;
    min-height: 45px;
    max-height: 46px;
    line-height: 23px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  .card_img {
    display: flex;
    align-items: center;
    height: 20px;
    img {
      width: 20px;
      height: 20px;
    }
  }
  .card_img img:first-child {
    margin-right: 8px;
  }
}
/* 图片部分 */
.van-card__thumb,
.col-card__thumb {
  width: 120px;
  height: 90px;
  /* overflow: hidden; */
  position: relative;
  top: 0;
  left: 0;
  text-align: center;
  background: url('//static.house730.com/m/images/house-bg.png');
  background-size: cover;
  border-radius: 4px;
  box-sizing: border-box;
}
.col-card__thumb__border {
  border: 3px solid #FF2119;
}
.van-card__thumb {
  margin-right: 16px;
}
.van-card__thumb img {
  width: 120px;
  height: 90px;
  border-radius: 1px;
  /* max-height: initial; */
}
.reviewed {
  font-size: 36px;
  position: absolute;
  left: 36%;
  bottom: 30%;
}
.col-vr {
  position: absolute;
  left: 5px;
  bottom: 5px;
  width: 24px;
  height: 24px;
}
.col-icon {
  position: absolute;
  /* top:-4px; */
  right: 4px;
  font-size: 20px;
  z-index: 5;
}
.saled {
  font-size: 17px;
  color: #ffffff;
  opacity: 0.55;
  background: #292630;
  width: 120px;
  height: 90px;
  line-height: 90px;
  position: absolute;
  left: 0;
  top: 0;
}
/* 分类标签部分 */
.van-card {
  padding: 0;
  background-color: #fff;
}
.van-ellipsis {
  overflow: inherit;
}
.van-card__content {
  text-align: left;
  height: auto;
  box-sizing: border-box;
  /* border-bottom:1px solid #EEEEEE; */
  padding: 0 15px 5px 0;
}
.van-card__tag {
  top: 0;
}
.col-plane {
  min-width: 120px;
}
.col-landlord-d > img,
.col-landlord-d-en > img,
.col-plane-d > img,
.col-plane-d-en > img {
  width: 14px;
  height: 14px;
  display: inline-block;
}
.col-landlord-d {
  width: 60px;
  height: 18px;
  padding: 0px 3px;
  background: #ffe3e3;
  border-radius: 2px;
  box-shadow: 0 0 0 1px #ed1c24;
  line-height: 18px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  margin-left: 1px;
  margin-top: 8px;
}
.col-landlord-d-en {
  width: 80px;
  height: 18px;
  padding: 0px 3px;
  background: #ffe3e3;
  border-radius: 2px;
  box-shadow: 0 0 0 1px #ed1c24;
  line-height: 18px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  margin-left: 1px;
  margin-top: 8px;
}
.col-plane-d {
  width: 60px;
  height: 18px;
  padding: 0px 3px;
  background: #e3f0ff;
  border-radius: 2px;
  box-shadow: 0 0 0 1px #056de0;
  line-height: 18px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  margin-left: 1px;
  margin-top: 8px;
}
.col-plane-d-en {
  width: 80px;
  height: 18px;
  padding: 0px 3px;
  background: #e3f0ff;
  border-radius: 2px;
  box-shadow: 0 0 0 1px #056de0;
  line-height: 18px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  margin-left: 1px;
  margin-top: 8px;
}
.landlord,
.landlord-en {
  line-height: 18px;
  margin-left: 2px;
  font-size: 12px;
  color: #ed1c24;
  transform: scale(0.95);
  transform-origin: 50% 100%;
}
.plane,
.plane-en {
  line-height: 18px;
  margin-left: 2px;
  font-size: 12px;
  color: #056de0;
  transform: scale(0.95);
  transform-origin: 50% 100%;
}
.col-tag {
  display: flex;
}
.col-tag p {
  height: 16px;
  /* line-height: 15px; */
  font-size: 10px;
  color: #ffffff;
  padding: 0 2px;
  /* margin:4px 0 0 4px; */
  border-radius: 2px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0 3.5px 0;
}
.imageNumber {
  position: absolute;
  top: 71px;
  left: 87px;
  width: 24px;
  height: 18px;
  background-color: rgba(0, 0, 0, 0.5);
  font-size: 12px;
  color: #fff;
  text-align: center;
  border-radius: 2px;
  line-height: 18px;
}
.col-label {
  width: 60px;
  position: absolute;
  top: 90px;
}
.col-top {
  background: linear-gradient(to right, #FF7B69, #FF4141);
  margin: 5px 0 0 6px;
  /* border-radius: 0 0 8px 0; */
  img {
    width: 9.5px;
    height: 10px;
    // vertical-align: middle;
    margin-top: -1px;
  }
}
.colsel{
  background: #f4a100;
}
.col-reviewd {
  background-color: #0054a6;
  margin: 75px 0 0 -28px !important;
}
.col-reviewd-en {
  background-color: #0054a6;
  margin: 74px 0 0 -52px !important;
}
.card-tags {
  font-size: 13px;
  color: #4d73bf;
}
/* 标签部分 */
.info-property-tags {
  max-height: 125px;
  margin-left: 16px;
  padding-right: 15px;
  text-align: left;
  display: inline-block;
}
.tags-span {
  color: #617e9d;
  margin: 0px 4px 4px 0;
  padding: 0 4px;
  font-size: 12px;
  line-height: 16px;
  display: inline-block;
  background-color: #eef8ff;
  max-width: 200px;
  font-family: PingFangSC-Regular;
}
.property {
  color: #536ea6;
  background-color: #dfe9ff;
}
/* 价格部分 */
.van-card__bottom {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  line-height: 13px;
}
.bh-price {
  display: flex;
  align-items: center;
  padding-right: 15px;
  padding-bottom: 9px;
}
.bh-plane {
  margin-right: 16px;
  width: 120px;
}
.bh-plane .icon {
  display: inline-block;
  width: 14px;
  height: 14px;
}
.bh-plane > .col-plane {
  margin-top: 8px;
}
.saleform {
  font-size: 10px;
  color: #333;
}
.card-price {
  font-size: 20px;
  color: #ed1c24;
  font-weight: bold;
  font-family: PingFangSC-Medium;
}
.card-price-small {
  margin-top: 2px;
  font-size: 14px;
  color: #ed1c24;
}
.card-price-small-en {
  margin-top: 5px;
  font-size: 14px;
  color: #ed1c24;
}
.card-price-green {
  color: #30b631;
}
.col-price {
  display: flex;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex-direction: row;
  align-items: flex-start;
}
.practical {
  padding-left: 4px;
  font-size: 11px;
  color: #999999;
  max-width: 50%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.practical span {
  font-size: 11px;
  line-height: 14px;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.build span {
  line-height: 14px;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.build {
  padding-left: 4px;
  font-size: 11px;
  color: #999999;
  max-width: 50%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.build-top {
  font-size: 11px;
  color: #333333;
}
.practical-top .practical-bottom {
  display: block;
  color: red;
}
.practical-top {
  font-size: 11px;
  color: #333333;
}
.contacts {
  display: flex;
  .col-plane {
    min-width: 120px;
  }
  .contacts_content {
    margin-left: 16px;
    width: 126px;
    height: 40px;
    padding: 7px 12px;
    background: #EDEFF2;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    border-radius: 4px;
    margin-bottom: 9px;
    img {
      width: 26px;
      height: 26px;
      object-fit: cover;
    }
    .button-grayed-out {
      // pointer-events: none;
      opacity: 0.5;
    }
  }
  .contacts_content img:first-child {
    border: 0.5px solid #CCCCCC;
  }
}
.vanDialog {
  .dialogClose {
    position: absolute;
    top: 24px;
    right: 24px;
    img {
      width: 20px;
      height: 20px;
    }
  }
  .image-container {
    object-fit: cover;
    margin-top: 74px;
    width: 130px;
    height: 130px;
    border-radius: 50%;
    box-sizing: border-box;
    box-shadow: 
    0 0 0 3px #ED1C24,
    0 0 0 6px rgba(237, 28, 36, 0.5);
  }
  .dialogTitle {
    margin-top: 24px;
    height: 25px;
    font-family: PingFangSC-SNaNpxibold;
    font-weight: 700;
    font-size: 18px;
    color: #333333;
    letter-spacing: 0;
  }
  .dialogNumber {
    margin-top: 10px;
    height: 25px;
    font-family: PingFangSC-SNaNpxibold;
    font-weight: 700;
    font-size: 18px;
    color: #333333;
    letter-spacing: 0;
  }
  .dialogButton {
    width: 142px;
    height: 44px;
    background: #ED1C24;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 44px auto;
    span {
      font-family: PingFangSC-Medium;
      font-weight: 500;
      font-size: 16px;
      color: #FFFFFF;
      letter-spacing: 0;
    }
    img {
      width: 16px;
      height: 16px;
      margin-left: 6px;
      vertical-align: middle;
    }
  }
}

.bottom {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
}
.col-remark-width {
  padding-right: 16px;
}
.col-remark {
  display: inline-block;
  margin-top: 2px;
  height: 18px;
  font-size: 12px;
  color: #999999;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.bh-company {
  margin: 5px 0 0 136px;
  font-size: 11px;
  color: #333333;
  height: 20px;
  padding-right: 15px;
}
</style>
